import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Item = Form.Item;
export enum EExportType {
  All = 'All',
  Any = 'Any',
}
const TagCondition = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      title={getI18n('customerTag.tagCondition.customerTagConditionSettings')}>
      <ItemWrapper
        title={getI18n('customerTag.tagCondition.customersmustmeet')}>
        <Item
          name={['conditions', 'matchType']}
          rules={[
            {
              required: true,
              message: getI18n('customerTag.tagCondition.pleaseselectatype'),
            },
          ]}>
          <RadioGroup className={css.group} disabled={props.disabled}>
            <RadioItem className={css.item} value={EExportType.All}>
              {getI18n('customerTag.tagCondition.all')}
            </RadioItem>
            <RadioItem value={EExportType.Any}>
              {getI18n('customerTag.tagCondition.any')}
            </RadioItem>
          </RadioGroup>
        </Item>
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default TagCondition;
